import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import TextareaAutosize from 'react-autosize-textarea';

import Link from 'components/Link';
import Emojis from 'components/Emojis';
import { getChatTextEditing, getChatWritingIndicator, getChatEmojis, getChatState } from 'selectors';
import * as actions from 'actions';
import './style.scss';

export class ChatTextInput extends Component {

  constructor() {
    super();

    this.pendingCaretPosition = -1;

    this.handleTextAreaKeyPress = this.handleTextAreaKeyPress.bind(this);
    this.handleMessageTextChange = this.handleMessageTextChange.bind(this);
    this.handleSendClick = this.handleSendClick.bind(this);
    this.handleEmojisClick = this.handleEmojisClick.bind(this);
    this.handleEmojiSelected = this.handleEmojiSelected.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.isDisabled && !nextProps.isDisabled) {
      this.focusIfNecessary();
    }
  }

  componentDidUpdate(prevProps) {
    if(this.pendingCaretPosition > 0) {
      this.refs.textarea.getTextareaDOMNode().selectionStart = this.pendingCaretPosition;
      this.refs.textarea.getTextareaDOMNode().selectionEnd = this.pendingCaretPosition;
      this.pendingCaretPosition = -1;
    }

    if(!prevProps.isChatOpened && this.props.isChatOpened) {
      // A bad hack to focus the input as we don't know when the animation ends (it won't focus if not in viewport).
      setTimeout(() => {
        this.focusIfNecessary();
      }, 200);
    }
  }

  focusIfNecessary() {
    if(window.innerWidth > process.env.KOOTH_MIN_WIDTH_TO_FOCUS_CHAT_INPUT) {
      this.focus();
    }
  }

  focus() {
    this.refs.textarea.getTextareaDOMNode().focus();
  }

  handleTextAreaKeyPress(event) {
    if(event.charCode === 13) {
      event.preventDefault();

      if(this.props.canSend) {
        this.props.onAddMessage(this.props.chatMessageText);
      }
    }
  }

  handleMessageTextChange(event) {
    const messageText = event.target.value;
    const isWritingNow = messageText.length > 0;

    this.props.onMessageTextChange(messageText);

    if (isWritingNow !== this.props.isUserWriting) {
      this.props.onMessageUpdateWritingIndicator(isWritingNow);
    }
  }

  handleSendClick(event) {
    event.preventDefault();

    if(this.props.canSend) {
      this.props.onAddMessage(this.props.chatMessageText);
    }
  }

  handleEmojisClick(event) {
    event.preventDefault();

    if(!this.props.isDisabled) {
      this.props.onEmojisToggle(this.props.showsEmojis);
    }
  }

  handleEmojiSelected(shortName) {
    this.pendingCaretPosition = this.getTextSelectionStart();
    this.props.onEmojiSelected(this.props.chatMessageText, shortName, this.pendingCaretPosition);
    this.focus();
  }

  getTextSelectionStart() {
    return this.refs.textarea.getTextareaDOMNode().selectionStart;
  }

  render() {
    return (
      <div className="ChatTextInput">

        <div className="textbox-holder">
          <form>
            <TextareaAutosize
              ref="textarea"
              value={this.props.chatMessageText}
              disabled={this.props.isDisabled}
              placeholder={__('members.chat.messagePlaceholder')}
              onChange={this.handleMessageTextChange}
              onKeyPress={this.handleTextAreaKeyPress} />
          </form>
        </div>

        <Link isDisabled={this.props.isDisabled} iconName="emoji" onClick={this.handleEmojisClick}>{__('members.chat.emoji')}</Link>
        <Link isDisabled={!this.props.canSend} onClick={this.handleSendClick} iconName="send">{__('members.chat.sendButton')}</Link>

        <Emojis isVisible={this.props.showsEmojis} onEmojiSelected={this.handleEmojiSelected} />
      </div>
    );
  }
}

ChatTextInput.propTypes = {
  onMessageUpdateWritingIndicator: PropTypes.func,
  onMessageTextChange: PropTypes.func,
  chatMessageText: PropTypes.string,
  onAddMessage: PropTypes.func,
  isDisabled: PropTypes.bool,
  canSend: PropTypes.bool,
  isChatOpened: PropTypes.bool,
  isUserWriting: PropTypes.bool,
  showsEmojis: PropTypes.bool,
  onEmojisToggle: PropTypes.func,
  onEmojiSelected: PropTypes.func
};

const mapStateToProps = state => {
  const textEditingState = getChatTextEditing(state, 'chatMessage');
  const chatMessageText = textEditingState.text;

  return {
    chatMessageText,
    canSend: chatMessageText.length > 0,
    isChatOpened: getChatState(state).isOpened,
    isUserWriting: getChatWritingIndicator(state),
    showsEmojis: getChatEmojis(state, 'chatMessage').areVisible
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onMessageTextChange: text => {
      dispatch(actions.chatMessageEditingUpdateText({ text }));
    },
    onAddMessage: text => {
      dispatch(actions.chatMessageAdd(text));
      dispatch(actions.chatMessageUpdateWritingIndicator(false));
    },
    onMessageUpdateWritingIndicator: isWriting => {
      dispatch(actions.chatMessageUpdateWritingIndicator(isWriting));
    },
    onEmojisToggle: showsEmojis => {
      if(!showsEmojis) {
        dispatch(actions.chatEmojisShow('chatMessage'));
      }
      else {
        dispatch(actions.chatEmojisHide('chatMessage'));
      }
    },
    onEmojiSelected: (text, emojiShortName, selectionStart) => {
      dispatch(actions.chatMessageEditingUpdateText({ text, emojiShortName, selectionStart }));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatTextInput);



/** WEBPACK FOOTER **
 ** ./src/members/Main/ChatWindow/ChatTextInput/index.js
 **/